import App from './App.svelte';

// import Usage from './usage.svelte';

const app = new App({
	target: document.querySelector( '#target' ),
	props: {
		name: 'world'
	}
});

export default app;